import React from 'react';

import type { IconButtonProps } from '@atlaskit/button/new';
import AutomationIcon from '@atlaskit/icon/core/automation';

export const AutomationGlyph: IconButtonProps['icon'] = (props) => (
	<AutomationIcon color="currentColor" {...props} />
);
